import AspApi from "api/ApiConfig";
// import { console } from "inspector";
import { Base64 } from "js-base64";

// CRM - SINGLE CONTACT ADD  -------------------

export const countryListApi = async () => {
  const res = await AspApi.get(`/api/v1/svc/aaa/authentication/get_countries`);
  return res;
};

export const cityListApi = async (provinceId) => {
  const res = await AspApi.get(
    `/api/v1/svc/aaa/authentication/get_cities?province_id=${provinceId}`
  );
  return res;
};
export const stateListApi = async (countryId) => {
  const res = await AspApi.get(
    `/api/v1/svc/aaa/authentication/get_provinces?country_id=${countryId}`
  );
  return res;
};

export const contactOriginApi = async () => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/contact_origin_types_list`
  );
  return res;
};

export const checkingApi = async (brandId, query) => {
  let qpm = [];

  if (query?.contact_type)
    qpm.push(`contact_type=${encodeURIComponent(query.contact_type)}`);
  if (query?.phone_number)
    qpm.push(`phone_number=${encodeURIComponent(query.phone_number)}`);
  if (query?.phone_country_code)
    qpm.push(
      `phone_country_code=${encodeURIComponent(query.phone_country_code)}`
    );
  if (query?.email) qpm.push(`email=${encodeURIComponent(query.email)}`);

  const qpmString = qpm.length > 0 ? `&${qpm.join("&")}` : "";
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/check_contact_exists?brand_id=${brandId}${qpmString}`
  );
  return res;
};

export const saveSingleContactApi = async (brandId, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/contact_persons?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

export const addTagsApi = async (brandId, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/tag?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

export const tagsListApi = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.search) qpm.push(`search=${query?.search}`);
  // if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/contacts/tag?brand_id=${brandId}&${qpmString}`
  );

  return res;
};

// CRM - TABLE  -------------------
export const crmListShow = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.search) qpm.push(`search=${query?.search}`);
  if (query?.user_id) qpm.push(`user_id=${query?.user_id}`);
  if (query?.contact_origin) qpm.push(`contact_origin=${query?.contact_origin}`);
  if (query?.tag_id) qpm.push(`tag_id=${query?.tag_id}`);

  if (query?.filters)
    qpm.push(`filters=${Base64.encode(JSON.stringify(query?.filters))}`);
  if (query?.send_report) {
    qpm.push(`send_report=${query?.send_report}`);
    // Only include selection params when generating report
    qpm.push(`select_all=${query?.select_all || false}`);
    if (query?.contact_person_ids && query?.contact_person_ids.length > 0) {
      qpm.push(`contact_person_ids=${query.contact_person_ids}`);
    }
  }
  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_persons?brand_id=${brandId}&${qpmString}`
  );
  return res;
};

// CRM - SingleContactView  -------------------

export const crmSingleContactView = async (brandId, id) => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_persons/${id}?brand_id=${brandId}`
  );
  return res;
};

export const crmContactTypes = async () => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/contact_categories_list`
  );
  return res;
};

export const crmProfessions = async () => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/professions_list`
  );
  return res;
};

// CRM - EDIT

export const crmSingleContactEdit = async (payLoad, id) => {
  const res = await AspApi.patch(
    `/api/v1/svc/contacts/contact_persons/${id}`,
    payLoad
  );
  return res;
};

//CRM-CLEAR
export const crmClear = async (contactPersonId, locationId, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/contact_persons/${contactPersonId}/location/${locationId}?brand_id=${brandId}`
  );
  return res;
};

export const crmTagsEdit = async (id, brandId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/tag/${id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

export const crmTagSingleAssign = async (contactId, id, brandId) => {
  const res = await AspApi.patch(
    `/api/v1/svc/contacts/contact_persons/${contactId}/tag/${id}/assign_tag?brand_id=${brandId}`
  );
  return res;
};

export const crmTagDelete = async (id, brandId) => {
  const res = await AspApi.delete(
    `/api/v1//svc/contacts/tag/${id}?brand_id=${brandId}`
  );
  return res;
};

export const crmTagRemove = async (contactId, id, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/contact_persons/${contactId}/tag/${id}/unassign_tag?brand_id=${brandId}`
  );
  return res;
};

// CRM - Bulk Tag Assign
export const crmBulkTagAssign = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/tag/bulk_tag_assign`,
    payLoad
  );
  return res;
};

//CRM ADD
export const crmSingleContactAdd = async (payLoad, id) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/contact_persons/${id}/contact_details`,
    payLoad
  );
  return res;
};

export const crmPhoneDelete = async (id, contactId, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/contact_persons/${id}/contact_details/${contactId}?brand_id=${brandId}`
    // { data: payLoad }
  );
  return res;
};

// Bulk upload

export const crmBulkUpload = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/contact_persons/bulk_upload`,
    payLoad
  );
  return res;
};

// Uploading Status

export const crmFileStatus = async (brand_id) => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_persons/bulk_upload_file_status?brand_id=${brand_id}`
  );
  return res;
};

// Status update

export const crmFileStatusUpdate = async (brand_id, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/contact_persons/update_user_seen?brand_id=${brand_id}`,
    payLoad
  );
  return res;
};

export const crmViewCount = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/failed_contacts_count?brand_id=${brandId}`
  );
  return res;
};

export const crmFileView = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/failed_contacts_list?brand_id=${brandId}&${qpmString}`
  );
  return res;
};

export const crmIgnore = async (brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/contact_utils/ignore_failed_contacts?brand_id=${brandId}`
  );
  return res;
};

export const crmListUpdate = async (payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/contact_utils/update_conflited_contact`,
    payLoad
  );
  return res;
};

// CRM Report Status
export const crmReportStatus = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/contacts/contact_utils/crm_report_status?brand_id=${brandId}`
  );
  return res;
};

export const crmTeamMembers = async (brandId, contact_conversation_id) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (contact_conversation_id)
    qpm.push(`contact_conversation_id=${contact_conversation_id}`);

  let qpmString = qpm.length > 0 ? "?" + qpm.join("&") : "";

  const res = await AspApi.get(
    `api/v1/svc/inbox/inbox_utils/team_members${qpmString}`
  );
  return res;
};


// CRM Report User Seen
export const crmReportUserSeen = async (brandId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/contact_utils/crm_report_user_seen?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

export const crmTags = async (brandId, contact_conversation_id) => {
  let qpm = [];

  // qpm.push(`limit=5`);

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (contact_conversation_id)
    qpm.push(`contact_conversation_id=${contact_conversation_id}`);

  let qpmString = qpm.length > 0 ? "?" + qpm.join("&") : "";

  const res = await AspApi.get(
    `/api/v1/svc/contacts/tag/pinned_tag_list${qpmString}`
    // `api/v1/svc/contacts/tag${qpmString}`
  );
  return res;
};


export const addPinnedTags = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/contacts/tag/${payLoad.tag_id}/pin_tag`,
    payLoad
  );
  return res;
};

export const removePinnedTags = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/contacts/tag/${payLoad.tag_id}/pin_tag`,
    payLoad
  );
  return res;
};


// Profile Attributes Related APIs
// Attribute Type List
export const AttributeTypes = async (brandId) => {
  if (!brandId) {
    throw new Error('brandId is required');
  }
  const res = await AspApi.get(
    `/api/v1/svc/contacts/profile_attribute_utils/attribute_types_list?brand_id=${brandId}`
  );
  return res;
};

// Attribute List
export const AttributeList = async (brandId, contact_person_id) => {
  let url = `api/v1/svc/contacts/profile_attribute_utils/scopes_and_attributes_list?brand_id=${brandId}`;

  // Only append contact_person_id if it's provided
  if (contact_person_id) {
    url += `&contact_person_id=${contact_person_id}`;
  }

  const res = await AspApi.get(url);
  return res;
};

// Attribute Scope Related APIs
// Create Attribute Scope
export const AttributeScopeCreate = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/attribute_scopes`,
    payLoad
  );
  return res;
};

// Update Attribute Scope
export const AttributeScopeUpdate = async (brandId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/attribute_scopes/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Delete Attribute Scope
export const AttributeScopeDelete = async (brandId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/attribute_scopes/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Profile Attribute Related APIs
// Create Profile Attribute
export const ProfileAttributeCreate = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/profile_attributes`,
    payLoad
  );
  return res;
};

// Update Profile Attribute
export const ProfileAttributeUpdate = async (brandId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/contacts/profile_attributes/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Delete Profile Attribute
export const ProfileAttributeDelete = async (brandId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/profile_attributes/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Profile Attribute Value Related APIs
// Create Profile Attribute Value
export const ProfileAttributeValueCreate = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/contacts/profile_attribute_values`,
    payLoad
  );
  return res;
};

// Update Profile Attribute Value
export const ProfileAttributeValueUpdate = async (brandId, payLoad) => {
  const url = `/api/v1/svc/contacts/profile_attribute_values/${payLoad.id}?` +
    `brand_id=${brandId}` +
    `&contact_person_id=${payLoad.contact_person_id}` +
    `&profile_attribute_id=${payLoad.profile_attribute_id}` +
    `&value=${encodeURIComponent(payLoad.value)}`;

  const res = await AspApi.put(url);
  return res;
};

// Delete Profile Attribute Value
export const ProfileAttributeValueDelete = async (brandId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/contacts/profile_attribute_values/${payLoad.id}?brand_id=${brandId}&contact_person_id=${payLoad.contact_person_id}`,
  );
  return res;
};



//Audience Set and Members APIs

//Audience Set APIs
// Audience Set Create
export const AudienceSetCreate = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/ams/audience_sets`,
    payLoad
  );
  return res;
};

// Audience Set Update
export const AudienceSetUpdate = async (brandId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/ams/audience_sets/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Audience Set Delete
export const AudienceSetDelete = async (brandId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/ams/audience_sets/${payLoad.id}?brand_id=${brandId}`,
    payLoad
  );
  return res;
};

// Audience Set single
export const AudienceSetSingle = async (brandId, id) => {
  const res = await AspApi.get(
    `/api/v1/svc/ams/audience_sets/${id}?brand_id=${brandId}`
  );
  return res;
};

// Audience Set List
export const AudienceSetList = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/ams/audience_sets?brand_id=${brandId}`
  );
  return res;
};

// Selection Criteria API
export const SelectionCriteriaList = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/ams/audience_sets/selection_criteria?brand_id=${brandId}`
  );
  return res;
};

// Audience Set Members List
export const AudienceSetMembersList = async (brandId, filters = '', addedIds = [], removedIds = [], page = 1, limit = 10, search = '', select_all = false, contact_person_ids = [], send_report = false) => {
  // Build the base URL with required parameters
  let url = `/api/v1/svc/ams/audience_set_members/members_list?brand_id=${brandId}&page=${page}&limit=${limit}&search=${search}`;

  // Add filters if provided
  if (filters) {
    url += `&${filters}`;
  }

  // Add added_contact_person_ids if provided
  if (addedIds?.length > 0) {
    url += `&added_contact_person_ids=${addedIds}`;
  }

  // Add removed_contact_person_ids if provided
  if (removedIds?.length > 0) {
    url += `&removed_contact_person_ids=${removedIds}`;
  }

  // Add select_all if provided
  if (select_all) {
    url += `&select_all=${select_all}`;
  }

  // Add contact_person_ids if provided
  if (contact_person_ids?.length > 0) {
    url += `&contact_person_ids=${contact_person_ids}`;
  }

  // Add send_report if provided
  if (send_report) {
    url += `&send_report=${send_report}`;
  }

  const res = await AspApi.get(url);
  return res;
};

// Members Remove
export const AudienceSetMembersRemove = async (brandId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/ams/audience_sets/${payLoad.id}/members/remove?brand_id=${brandId}`,
    { data: { contact_person_ids: payLoad.contact_person_ids, select_all: payLoad.select_all } }
  );
  return res;
};

// Audience set delete version
export const AudienceSetDeleteVersion = async (brandId, id, segment_id) => {
  const res = await AspApi.delete(
    `api/v1/svc/ams/audience_sets/${id}/segments/${segment_id}?brand_id=${brandId}`,
  );
  return res;
};

// Audience Set set current version
export const AudienceSetSetVersion = async (brandId, id, version) => {
  const res = await AspApi.patch(
    `api/v1/svc/ams/audience_sets/${id}/set_current?brand_id=${brandId}&segment_version=${version}`,
  );
  return res;
};

// Move members from one audience set to another
export const AudienceSetMoveMembers = async (brandId, payLoad) => {
  const res = await AspApi.patch(
    `/api/v1/svc/ams/audience_set_members/move_members?brand_id=${brandId}`,
    payLoad
  );
  return res;
};
